// extracted by mini-css-extract-plugin
export default {"card":"TeamTabs_card__XbcDk","photo":"TeamTabs_photo__j0vJo","data":"TeamTabs_data__bMYpm","info":"TeamTabs_info__wPDhr"};